import { render, staticRenderFns } from "./ValidationStatueObligee.vue?vue&type=template&id=2d12bc5b&scoped=true&"
import script from "./ValidationStatueObligee.vue?vue&type=script&lang=js&"
export * from "./ValidationStatueObligee.vue?vue&type=script&lang=js&"
import style1 from "./ValidationStatueObligee.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12bc5b",
  null
  
)

export default component.exports